import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  productData: null,

  searchProductData: null,
  leadsexhausted: false, //For Search Products
  lastDoc: null,
  limit: 8,
  loadMore: false,
  loading: false,
  sectionProductsLoading: false,
  sectionLoading: false,
  singleProduct: null,
  searchKeys: null,
  searchLoading: false,
  deleteProductLoading: false,
  editSectionLoading: false,
  homeSections: [],
  homeSectionProducts: {},
  addSectionLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HOMEPRODUCTS:
      return updateObject(state, action.payload);
    case actionTypes.HOMEPRODUCTS_LOADING:
      return updateObject(state, action.payload);
    case actionTypes.HOME_SECTION_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
